import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { EmojiIcon } from '../EmojiIcon';
import styles from './PauseSlideContentV25.css';

const PARTS = [
    { title: 'The\nThickness', icon: 'books' },
    { title: 'The\nGenre', icon: 'performing-arts' },
    { title: 'The Heat', icon: 'hot-pepper' }
];

function PauseSlideContentV25({ heading, nextIcon, nextTitle, fact, completedParts, spriteVersion }) {
    const renderPart = (part, index) => {
        if (index < completedParts) {
            return (
                <li key={part.title} className={styles.partSaved}>
                    <EmojiIcon name={part.icon} version={spriteVersion} />
                    <span className={styles.partTitle}>{part.title}</span>
                    <span className={styles.hidden} aria-hidden='true'>Hidden until the end</span>
                    <span className={styles.savedBadge}>
                        <Icon name='checkItemFilled' className={styles.savedIcon} />
                        Saved
                    </span>
                </li>
            );
        }

        const isNext = index === completedParts;

        return (
            <li key={part.title} className={isNext ? styles.partNext : styles.partWaiting}>
                <span className={styles.partHead}>
                    <EmojiIcon name={part.icon} version={spriteVersion} />
                    <span className={styles.partTitle}>{part.title}</span>
                </span>
                {isNext ? (
                    <span className={styles.nextBadge}>Up next</span>
                ) : (
                    <span className={styles.status}>Waiting</span>
                )}
            </li>
        );
    };

    return (
        <section className={styles.form}>
            <h2 className={styles.heading}>{heading}</h2>
            <p className={styles.subheading}>You’ll see it on your cover at the end. Next:</p>
            <p className={styles.next}>
                <EmojiIcon name={nextIcon} version={spriteVersion} />
                {nextTitle}
            </p>
            <ul className={styles.parts}>
                {PARTS.map(renderPart)}
            </ul>
            <p className={styles.fact}>
                <EmojiIcon name='light-bulb' version={spriteVersion} />
                <span>{fact}</span>
            </p>
        </section>
    );
}

PauseSlideContentV25.propTypes = {
    heading: PropTypes.string.isRequired,
    nextIcon: PropTypes.string.isRequired,
    nextTitle: PropTypes.string.isRequired,
    fact: PropTypes.string.isRequired,
    completedParts: PropTypes.number.isRequired,
    spriteVersion: PropTypes.string.isRequired
};

export {
    PauseSlideContentV25
};
